// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Alert, Snackbar } from '@mui/material';

interface Props {
  isOpen: boolean;
  message: string;
  onClose: () => void;
}

/**
 * A snackbar for user-facing known errors — surfaces the backend message
 * verbatim without support-contact copy. Use for status-level known errors
 * where the user's intent no longer matches server state (e.g. the invoice
 * transitioned out of a payable state, a charge was already cancelled).
 *
 * Do NOT use for unknown or unexpected errors — those must use
 * SupportSnackbar, which pairs with Sentry reporting.
 */
export function KnownErrorSnackbar(props: Props) {
  return (
    <Snackbar
      open={props.isOpen}
      onClose={props.onClose}
      autoHideDuration={6000}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert severity="warning" onClose={props.onClose} variant="filled">
        {props.message}
      </Alert>
    </Snackbar>
  );
}
